import { Box, FormControlLabel, Radio, RadioGroup, SvgIcon, Typography } from "@mui/material";
import { appContext } from "../../../../AppContext";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import IbssDrawer from "../../../../Components/Drawer/IbssDrawer";
import IbssButton from "../../../../Components/Buttons/Button/IbssButton";
import { DateTime } from "luxon";
import Helper from "../../../../Common/Helper";
import CloseIcon from "../../../../Components/Icons/CloseIcon";
import { IDestination, SignPost } from "./DataModels";
import QuickLinkForm, { applicationType } from "./QuickLinkForm";
import KpiForm from "./KpiForm";
import { DateHelper } from "../../../../Common/DateHelper";
import { IShortcutsRequestModel } from "../../../../Providers.IbssApiClientV2/IbssApiClientV2";
import IbssPageHeader from "../../../../Components/Headings/PageHeading/IbssPageHeader";

class EditSignpostDrawer extends IbssComponent<IProps, IState>
{
    private get apiClient() { return appContext().apiClient; }
    private get labels() { return appContext().labels; }
    private appState = appContext().state;

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            kpiPostType: 0,
            heading: "",
            label: "",
            subHeading: "",
            labelLink: "",
            maximumCount: "",
            kpiLimit1: "",
            kpiLimit2: "",
            textBox1: "",
            textBox2: "",
            textBox3: "",
            initialKpiValue: "",
            valueUrl1: "",
            actionLabel: "",
            signpostOrder: ["1", "2", "3", "4", "5"],
            selectedQuickLinkOrder: "1",
            selectedKPIOrder: "1",
            valueUrl2: "",
            Application: [this.labels.funcFlex_S],
            tagType: TagType.QuickLink,
            destination: {
                Web: "",
                Android: "",
                iOS: ""
            },
            actionUri: "",
            selectedId: 0,
            startDate: DateTime.now(),
            endDate: DateTime.now(),
            kpiImageUrl: '',
            quicklinkImageUrl: '',
            quicklinkIconUrl: '',
            isLoading: false,
            erroredFields: {
                textBox1: false,
                textBox2: false,
                textBox3: false,
                applications: false,
                startDate: false,
                endDate: false,
                destinationWeb: false,
                destinationAndroid: false,
                destinationIOS: false,
                dateRange: false,
                initialKpiValue: false,
                label: false,
                actionUri: false,
                heading: false,
                labelLink: false
            },
            showErrors: false,
            isEnabled: 0
        };
    }

    public setKpiType(kpitype: string): number
    {
        let kpiPostType = 0;
        switch (kpitype)
        {
            case "NumberSlider":
                kpiPostType = 0;
                break;
            case "TextSlider":
                kpiPostType = 1;
                break;
            case "NumberOnly":
                kpiPostType = 2;
                break;
            case "TextOnly":
                kpiPostType = 3;
                break;
            default:
                kpiPostType = 0;
        }
        return kpiPostType;
    }

    public async componentDidUpdate(prevProps: IProps): Promise<void>
    {
        if (prevProps.open !== this.props.open && this.props.open)
        {
            this.resetState();

        }
        if (prevProps.selectedSignpostId !== this.props.selectedSignpostId)
        {
            if (!this.props.isEditMode)
            {
                this.resetState();
                return;
            }
            try
            {
                const response =
                    await appContext().ibssApiClientV2.v2.byNodeid.shortcuts.byId.get<SignPost>(
                        {
                            nodeId: this.props.buildingId,
                            id: this.props.selectedSignpostId,
                            select: SignPost,
                        }
                    );

                if (response.SignPostType === "QuickLink")
                {
                    this.setState({
                        tagType: TagType.QuickLink,
                        kpiPostType: this.setKpiType(response.KPIType),
                        Application: response.Application,
                        heading: response.Heading,
                        subHeading: response.SubHeading,
                        labelLink: response.Label,
                        destination: {
                            Web: response.Destination.Web,
                            Android: response.Destination.Android,
                            iOS: response.Destination.iOS
                        },
                        startDate: response.StartDate
                            ? response.StartDate
                            : DateHelper.now(this.props.buildingId),
                        endDate: response.EndDate
                            ? response.EndDate
                            : DateHelper.now(this.props.buildingId),
                        quicklinkImageUrl: response.Image,
                        quicklinkIconUrl: response.Icon,
                        selectedQuickLinkOrder: response.BuildingKPI_Order.toString(),
                        isEnabled: response.IsEnabled
                    });
                } else if (response.SignPostType === "KPI")
                {

                    this.setState({
                        tagType: TagType.KPI,
                        label: response.Label,
                        kpiPostType: this.setKpiType(response.KPIType),
                        maximumCount: response.MaximumCount?.toString() || "",
                        kpiLimit1: response.Limit1?.toString() || "",
                        kpiLimit2: response.Limit2?.toString() || "",
                        textBox1: response.Text0 || "",
                        textBox2: response.Text1 || "",
                        textBox3: response.Text2 || "",
                        initialKpiValue: response.Value ? Number(response.Value).toFixed(2) : "",
                        valueUrl1: response.ValueURI || "",
                        actionLabel: response.ActionLabel || "",
                        selectedQuickLinkOrder: response.BuildingKPI_Order?.toString() || "1",
                        kpiImageUrl: response.Image,
                        selectedKPIOrder: response.BuildingKPI_Order.toString(),
                        isEnabled: response.IsEnabled,
                        actionUri: response.ActionURI || ""
                    });
                }
            } catch
            { }
        }
    }

    private resetState(): void
    {
        this.setState({
            kpiPostType: 0,
            heading: "",
            label: "",
            subHeading: "",
            labelLink: "",
            maximumCount: "",
            kpiLimit1: "",
            kpiLimit2: "",
            textBox1: "",
            textBox2: "",
            textBox3: "",
            initialKpiValue: "",
            valueUrl1: "",
            actionLabel: "",
            valueUrl2: "",
            Application: [this.labels.funcFlex_S],
            selectedQuickLinkOrder: "1",
            selectedKPIOrder: "1",
            tagType: TagType.QuickLink,
            destination: {
                Web: "",
                Android: "",
                iOS: ""
            },
            selectedId: 0,
            startDate: DateTime.now(),
            endDate: DateTime.now(),
            actionUri: '',
            erroredFields: {
                textBox1: false,
                textBox2: false,
                textBox3: false,
                applications: false,
                startDate: false,
                endDate: false,
                destinationWeb: false,
                destinationAndroid: false,
                destinationIOS: false,
                dateRange: false,
                initialKpiValue: false,
                label: false,
                actionUri: false,
                heading: false,
                labelLink: false
            },
            showErrors: false,
            kpiImageUrl: '',
            quicklinkImageUrl: '',
            quicklinkIconUrl: '',
            isEnabled: 0
        });
    };

    public async refreshList(): Promise<void>
    {
        await this.props.loadSignpostDetails();
    }

    private tagTypeChanged(event: React.ChangeEvent<HTMLInputElement>): void 
    {
        const tagType = event.target.value as TagType;
        this.setState({
            tagType,
            heading: "",
            showErrors: false,
            erroredFields: {
                textBox1: false,
                textBox2: false,
                textBox3: false,
                applications: false,
                startDate: false,
                endDate: false,
                destinationWeb: false,
                destinationAndroid: false,
                destinationIOS: false,
                dateRange: false,
                initialKpiValue: false,
                label: false,
                actionUri: false,
                heading: false,
                labelLink: false
            }
        });
    };

    private handleKpiImageSelect(imageUrl: string): void
    {
        this.setState({
            kpiImageUrl: imageUrl
        });
    }

    private handleQuickLinkImageSelect(imageUrl: string): void
    {
        this.setState({
            quicklinkImageUrl: imageUrl
        });
    }

    private handleQuickLinkIconSelect(imageUrl: string): void
    {
        this.setState({
            quicklinkIconUrl: imageUrl
        });
    }

    private async saveSignpostData(): Promise<void>
    {
        const commonPayload = {
            KPIType: this.state.kpiPostType,
            IsEnabled: this.state.isEnabled
        };

        const destination = {
            Web: this.state.Application.contains(this.labels.funcFlex_S) ? this.state.destination.Web : '',
            Android: this.state.Application.contains(this.labels.funcRoamer_S) ? this.state.destination.Android : '',
            iOS: this.state.Application.contains(this.labels.funcRoamer_S) ? this.state.destination.iOS : ''
        };

        const payload: IShortcutsPayload = this.state.tagType === TagType.QuickLink ? {
            ...commonPayload,
            SignPostType: "QuickLink",
            Application: this.state.Application,
            Heading: this.state.heading,
            SubHeading: this.state.subHeading,
            Label: this.state.labelLink,
            BuildingKPI_Order: Number(this.state.selectedQuickLinkOrder),
            destination,
            StartDate: this.state.startDate.date().setZoneByNode(this.appState.buildingId).toUTC().toISO(),
            EndDate: this.state.endDate.date().setZoneByNode(this.appState.buildingId).toUTC().toISO(),
            Image: this.state.quicklinkImageUrl,
        } : {
            ...commonPayload,
            SignPostType: "KPI",
            Label: this.state.label,
            BuildingKPI_Order: Number(this.state.selectedKPIOrder),
            MaximumCount: this.state.maximumCount,
            BuildingKPI_Limit1: Number(this.state.kpiLimit1),
            BuildingKPI_Limit2: Number(this.state.kpiLimit2),
            BuildingKPI_Text0: this.state.textBox1,
            BuildingKPI_Text1: this.state.textBox2,
            BuildingKPI_Text2: this.state.textBox3,
            BuildingKPI_Value: Number(this.state.initialKpiValue),
            ActionLabel: this.state.actionLabel,
            Image: this.state.kpiImageUrl,
            ActionURI: this.state.actionUri,
            ValueURI: this.state.valueUrl1,
        };

        try
        {
            if (this.props.selectedSignpostId === "")
            {
                await appContext().ibssApiClientV2.v2.byNodeid.shortcuts.post({
                    body: payload,
                    nodeId: this.props.buildingId,
                });
            }
            else
            {
                await appContext().ibssApiClientV2.v2.byNodeid.shortcuts.byId.put({
                    nodeId: this.props.buildingId,
                    id: String(this.props.selectedSignpostId),
                    body: payload,
                });
            }
            await this.refreshList();
        }
        catch
        {
        }
    }
    private isTextMandatory(): boolean
    {
        return this.state.kpiPostType === 1 || this.state.kpiPostType === 3;
    }

    private isValidUrl(url: string): boolean
    {
        try
        {
            new URL(url);
            return true;
        }
        catch
        {
            return false;
        }
    }
    private validateFields(): IErroredFields
    {
        const isWebMandatory = this.state.Application.contains(this.labels.funcFlex_S) && !this.state.Application.contains(this.labels.funcRoamer_S);
        const isRoamerMandatory = this.state.Application.contains(this.labels.funcRoamer_S) && !this.state.Application.contains(this.labels.funcFlex_S);

        let fieldValidation = {
            textBox1:
                this.state.tagType === TagType.KPI &&
                (this.state.kpiPostType === 1 || this.state.kpiPostType === 3) &&
                !(this.state.textBox1 && this.state.textBox1.length > 0),
            textBox2:
                this.state.tagType === TagType.KPI &&
                (this.state.kpiPostType === 1 || this.state.kpiPostType === 3) &&
                !(this.state.textBox2 && this.state.textBox2.length > 0),
            textBox3:
                this.state.tagType === TagType.KPI &&
                (this.state.kpiPostType === 1 || this.state.kpiPostType === 3) &&
                !(this.state.textBox3 && this.state.textBox3.length > 0),
            initialKpiValue:
                this.state.tagType === TagType.KPI &&
                !(this.state.initialKpiValue && this.state.initialKpiValue.length > 0),
            label:
                this.state.tagType === TagType.KPI &&
                !(this.state.label && this.state.label.length > 0),
            applications:
                this.state.tagType === TagType.QuickLink &&
                (!this.state.Application || this.state.Application.length === 0),
            startDate:
                this.state.tagType === TagType.QuickLink && !this.state.startDate,
            endDate: this.state.tagType === TagType.QuickLink && !this.state.endDate,
            destinationWeb:
                this.state.tagType === TagType.QuickLink &&
                ((isWebMandatory && !this.state.destination.Web) ||
                    (this.state.destination.Web.length > 0 && !this.isValidUrl(this.state.destination.Web))),
            destinationAndroid:
                this.state.tagType === TagType.QuickLink &&
                ((isRoamerMandatory && !this.state.destination.Android) ||
                    (this.state.destination.Android.length > 0 && !this.isValidUrl(this.state.destination.Android))),
            destinationIOS:
                this.state.tagType === TagType.QuickLink &&
                ((isRoamerMandatory && !this.state.destination.iOS) ||
                    (this.state.destination.iOS.length > 0 && !this.isValidUrl(this.state.destination.iOS))),
            dateRange:
                this.state.tagType === TagType.QuickLink &&
                (!this.state.startDate ||
                    !this.state.endDate ||
                    this.state.startDate > this.state.endDate),
            labelLink:
                this.state.tagType === TagType.QuickLink &&
                (!(this.state.labelLink && this.state.labelLink.length <= 50 && this.state.labelLink.trim().length > 0)),
            actionUri:
                this.state.tagType === TagType.KPI &&
                !(this.state.actionUri && this.state.actionUri.length > 0),
            heading:
                this.state.tagType === TagType.QuickLink &&
                (!(this.state.heading && this.state.heading.length <= 50 && this.state.heading.trim().length > 0)),

        };

        return fieldValidation;
    }

    private async saveSignpostUpdate(): Promise<void>
    {
        if (this.state.isLoading)
        {
            return;
        }
        try
        {
            this.setState({ isLoading: true });
            const isDateValid =
                this.state.tagType === TagType.QuickLink
                    ? this.state.startDate &&
                    this.state.endDate &&
                    this.state.startDate <= this.state.endDate
                    : true;

            await this.setStateAsync({
                erroredFields: {
                    ...this.validateFields(),
                    dateRange: this.state.tagType === TagType.QuickLink && !isDateValid,
                },
            });

            if (Object.values(this.state.erroredFields).includes(true))
            {
                this.setState({ showErrors: true });
                return;
            }

            await this.saveSignpostData();
            this.resetState();
            this.props.onClose();
        }
        finally
        {
            this.setState({ isLoading: false });
        }
    }

    private handleQuickLinkStartDateChange(date: DateTime): void
    {
        this.setState({ startDate: date });
    };

    private handleQuickLinkEndDateChange(date: DateTime): void
    {
        this.setState({ endDate: date });
    };


    private handleKpiTextBox1Change(value: string): void
    {
        this.setState({
            textBox1: value,
            erroredFields: {
                ...this.state.erroredFields,
                textBox1: false
            }
        });
    }

    private handleKpiTextBox2Change(value: string): void
    {
        this.setState({
            textBox2: value,
            erroredFields: {
                ...this.state.erroredFields,
                textBox2: false
            }
        });
    }

    private handleKpiTextBox3Change(value: string): void 
    {
        this.setState({
            textBox3: value,
            erroredFields: {
                ...this.state.erroredFields,
                textBox3: false
            }
        });
    }

    private handleInitialKpiValueChange(value: string): void 
    {
        this.setState({
            initialKpiValue: value,
            erroredFields: {
                ...this.state.erroredFields,
                initialKpiValue: false
            }
        });
    }

    private handleKpiTypeChange(kpiType: number): void
    {
        this.setState({
            kpiPostType: kpiType,
            erroredFields: {
                ...this.state.erroredFields,
                textBox1: false,
                textBox2: false,
                textBox3: false
            }
        });
    }

    private handleQuickLinkDestinationWebChange(value: string): void 
    {
        this.setState({
            destination: {
                ...this.state.destination,
                Web: value
            },
            erroredFields: {
                ...this.state.erroredFields,
                destinationWeb: false
            }
        });
    }

    private handleQuickLinkDestinationAndroidChange(value: string): void
    {
        this.setState({
            destination: {
                ...this.state.destination,
                Android: value
            },
            erroredFields: {
                ...this.state.erroredFields,
                destinationAndroid: false
            }
        });
    }

    private handleQuickLinkDestinationIOSChange(value: string): void
    {
        this.setState({
            destination: {
                ...this.state.destination,
                iOS: value
            },
            erroredFields: {
                ...this.state.erroredFields,
                destinationIOS: false
            }
        });
    }

    private handleStatusChange(value: boolean): void
    {
        this.setState({
            isEnabled: value === true ? 1 : 0,
        });
    }

    private handleQuickLinkApplicationChange(value: string): void
    {
        this.setState({
            Application: value === applicationType.flexAndRoamer ? [applicationType.flex, applicationType.roamer] : [value],
            erroredFields: {
                ...this.state.erroredFields,
                applications: false,
                destinationWeb: false,
                destinationAndroid: false,
                destinationIOS: false
            }
        });
    }
    public render(): JSX.Element
    {
        return (
            <IbssDrawer
                open={this.props.open}
                onClose={this.props.onClose}
                anchor="right"
                className="flex-search-filter-criteria"
                sx={{ backgroundColor: "var(--ui-background-alternate)" }}
            >
                <Box sx={{ p: 2 }}>
                    <Box display={"flex"} sx={{ cursor: "pointer" }} justifyContent={"flex-end"}>
                        <SvgIcon onClick={() =>
                        {
                            this.resetState();
                            this.props.onClose();
                        }}>
                            <CloseIcon />
                        </SvgIcon>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <IbssPageHeader
                            title={this.props.isEditMode ? this.labels.Admin_Signposts_EditTitle : this.labels.Admin_Signposts_CreateTitle}
                            description={this.props.isEditMode ? this.labels.Admin_Signposts_EditSubtitle : this.labels.Admin_Signposts_CreateSubtitle}
                        />
                        <Box my={2} px={1}>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={this.state.tagType}
                                onChange={(e) => this.tagTypeChanged(e)}
                            >
                                <FormControlLabel
                                    value={TagType.QuickLink}
                                    control={<Radio />}
                                    label="QuickLink"
                                />

                                <FormControlLabel
                                    value={TagType.KPI}
                                    control={<Radio />}
                                    label="KPI"
                                />
                            </RadioGroup>
                        </Box>

                        {this.state.tagType === TagType.QuickLink ? (
                            <QuickLinkForm
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onStartDateChange={(date) => this.handleQuickLinkStartDateChange(date)}
                                onEndDateChange={(date) => this.handleQuickLinkEndDateChange(date)}
                                datesDisabled={false}
                                application={this.state.Application}
                                onApplicationTypeChange={(e) => this.handleQuickLinkApplicationChange(e)}
                                signpostOrder={this.state.signpostOrder}
                                selectedQuickLinkOrder={this.state.selectedQuickLinkOrder}
                                onQuickLinkOrderChange={(e) => this.setState({ selectedQuickLinkOrder: e })}
                                heading={this.state.heading}
                                onHeadingChange={(e) => this.setState({ heading: e })}
                                subHeading={this.state.subHeading}
                                onSubHeadingChange={(e) => this.setState({ subHeading: e })}
                                labelLink={this.state.labelLink}
                                onLabelLinkChange={(e) => this.setState({ labelLink: e })}
                                destinationWeb={this.state.destination.Web}
                                onDestinationWebChange={(e) => this.handleQuickLinkDestinationWebChange(e)}
                                destinationAndroid={this.state.destination.Android}
                                onDestinationAndroidChange={(e) => this.handleQuickLinkDestinationAndroidChange(e)}
                                destinationIOS={this.state.destination.iOS}
                                onDestinationIosChange={(e) => this.handleQuickLinkDestinationIOSChange(e)}
                                isEnabled={this.state.isEnabled}
                                onStatusChange={(checked) => this.handleStatusChange(checked)}
                                images={this.props.images}
                                onImageUpload={this.props.onImageUpload}
                                showErrors={this.state.showErrors}
                                errorFields={this.state.erroredFields}
                                onImageSelect={(e) => this.handleQuickLinkImageSelect(e)}
                                imageUrl={this.state.quicklinkImageUrl}
                                onIconSelect={(e) => this.handleQuickLinkIconSelect(e)} 
                            />
                        ) : (
                            <KpiForm
                                kpiPostType={this.state.kpiPostType}
                                onSignpostTypeChange={(value) => this.handleKpiTypeChange(value)}
                                label={this.state.label}
                                onLabelChange={(e) => this.setState({ label: e })}
                                signpostOrder={this.state.signpostOrder}
                                selectedKPIOrder={this.state.selectedKPIOrder}
                                maximumCount={this.state.maximumCount}
                                onMaximumCountChange={(e) => this.setState({ maximumCount: e })}
                                kpiLimit1={this.state.kpiLimit1}
                                onKpiLimit1Change={(e) => this.setState({ kpiLimit1: e })}
                                kpiLimit2={this.state.kpiLimit2}
                                onKpiLimit2Change={(e) => this.setState({ kpiLimit2: e })}
                                textBox1={this.state.textBox1}
                                onTextBox1Change={(e) => this.handleKpiTextBox1Change(e)}
                                textBox2={this.state.textBox2}
                                onTextBox2Change={(e) => this.handleKpiTextBox2Change(e)}
                                textBox3={this.state.textBox3}
                                onTextBox3Change={(e) => this.handleKpiTextBox3Change(e)}
                                initialKpiValue={this.state.initialKpiValue}
                                onInitialKpiValueChange={(e) => this.handleInitialKpiValueChange(e)}
                                valueUrl1={this.state.valueUrl1}
                                onValueUrl1Change={(e) => this.setState({ valueUrl1: e })}
                                actionLabel={this.state.actionLabel}
                                onActionLabelChange={(e) => this.setState({ actionLabel: e })}
                                actionUri={this.state.actionUri}
                                onActionUriChange={(e) => this.setState({ actionUri: e })}
                                images={this.props.images}
                                onImageUpload={this.props.onImageUpload}
                                showErrors={this.state.showErrors}
                                errorFields={this.state.erroredFields}
                                onImageSelect={(e) => this.handleKpiImageSelect(e)}
                                imageUrl={this.state.kpiImageUrl}
                                onKpiOrderChange={(e) => this.setState({ selectedKPIOrder: e })}
                                isTextMandatory={this.isTextMandatory()}
                                isEnabled={this.state.isEnabled}
                                onStatusChange={(checked) => this.handleStatusChange(checked)}
                            />
                        )}
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mt: 2 }}>
                            <IbssButton variant="contained" color="secondary" onClick={this.props.onClose}>
                                {this.labels.HubButtonCancel}
                            </IbssButton>

                            <IbssButton variant="contained" color="primary" onClick={() => this.saveSignpostUpdate()}
                                disabled={this.state.isLoading || Object.values(this.validateFields()).includes(true)}
                            >
                                {this.props.isEditMode ? this.labels.HubLabelUpdate : this.labels.funcButtonAddField_S}
                            </IbssButton>
                        </Box>
                    </Box>
                </Box>
            </IbssDrawer>
        );
    }
}

export default EditSignpostDrawer;

export interface IProps
{
    open: boolean;
    onClose: () => void;
    selectedIdChanged: (id: string) => void;
    isEditMode: boolean;
    buildingId: number;
    selectedSignpostId: string;
    loadSignpostDetails: () => Promise<void>;
    images: IFile[];
    onImageUpload: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;

}
export interface IState
{
    kpiPostType: number;
    heading: string;
    label: string;
    subHeading: string;
    maximumCount: string;
    kpiLimit1: string;
    kpiLimit2: string;
    textBox1: string;
    textBox2: string;
    textBox3: string;
    initialKpiValue: string;
    valueUrl1: string;
    actionLabel: string;
    valueUrl2: string;
    labelLink: string;
    selectedId: number;
    tagType: TagType;
    destination: IDestination;
    startDate: DateTime;
    endDate: DateTime;
    erroredFields: IErroredFields;
    showErrors: boolean;
    signpostOrder: string[];
    selectedQuickLinkOrder: string;
    selectedKPIOrder: string
    isLoading: boolean;
    kpiImageUrl: string;
    quicklinkImageUrl: string;
    quicklinkIconUrl: string
    Application: string[]
    actionUri: string
    isEnabled: number
}
export interface IFile
{
    name: string;
    path: string;
    lastModified: string;
    createdAt: string;
    size: string;
}
export interface IErroredFields
{
    textBox1: boolean;
    textBox2: boolean;
    textBox3: boolean;
    applications: boolean;
    startDate: boolean;
    endDate: boolean;
    destinationWeb: boolean;
    destinationAndroid: boolean;
    destinationIOS: boolean;
    dateRange: boolean;
    initialKpiValue: boolean;
    label: boolean;
    actionUri: boolean;
    heading: boolean;
    labelLink: boolean;
}

export enum TagType
{
    QuickLink = "QuickLink",
    KPI = "KPI",
}

export interface IShortcutsPayload extends IShortcutsRequestModel
{
    destination?:
    { Web: string, Android: string, iOS: string },
    BuildingKPI_Limit1?: number,
    BuildingKPI_Limit2?: number,
}
